import { api } from 'api'
import { z } from 'zod'

const getCompanyFilesRequest = z.object({
  companyId: z.number(),
  /** startsWith FileHandle.path match (ie for getting all documents within a directory) */
  prefix: z.string().optional(),
  /** which FileHandle fields to include in the response */
  includes: z.array(z.enum(['type', 'temp_url', 'extra'])).optional(),
  /** FileHandle.type */
  type: z.string().optional(),
})

export type GetCompanyFilesRequest = z.infer<typeof getCompanyFilesRequest>

const getCompanyFilesResponse = z.object({
  files: z.array(
    z.object({
      id: z.number(),
      tempUrl: z.string(),
      path: z.string(),
    })
  ),
})

export async function getCompanyFiles(
  request: z.infer<typeof getCompanyFilesRequest>
) {
  const { companyId, ...params } = getCompanyFilesRequest.parse(request)

  return api
    .get(`/company/${companyId}/files`, { params })
    .then((response) => response.data)
    .then(getCompanyFilesResponse.parse)
}
